
export function getStyles(_, { palette = {} }) {
  return {
    dropdownSearchBoxMenu: {
      width: 800,
      maxHeight: 300,
      '& .menu-header': {
        display: 'flex',
        color: palette.neutralPrimary,
        '& .ms-StackItem': {
          flex: 1,
          fontWeight: 'bold',
          padding: 10,
          '&.app-no-col': {
            textAlign: 'right',
            flex: 'none',
          },
        },
      },
      '& .menu-item': {
        display: 'flex',
        color: palette.neutralPrimary,
        cursor: 'pointer',
        '&:hover': {
          background: palette.neutralLighter,
        },
        '& .ms-StackItem': {
          flex: 1,
          padding: 10,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        },
      },
      '& .menu-empty': {
        padding: 10,
      },
      '& .menu-loading': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 200,
        '& .ms-Spinner': {
          margin: 5,
        },
        '& span': {
          color: palette.themePrimary,
        },
      },
    },
  };
}
